// extracted by mini-css-extract-plugin
export var addViewLink = "_7-1";
export var availabilityIcon = "_7-16";
export var availabilitySelectionIcon = "_7-15";
export var backButton = "_7-2";
export var backIcon = "_7-z";
export var conversationCount = "_7-3";
export var dragHandle = "_7-5";
export var dropdown = "_7-e";
export var dropdownIcon = "_7-7";
export var dropdownOption = "_7-6";
export var dropdownTriangle = "_7-d";
export var expand = "_7-f";
export var folder = "_7-i";
export var folderItem = "_7-c";
export var icon = "_7-8";
export var iconRow = "_7-9";
export var image = "_7-a";
export var logo = "_7-b";
export var navContainer = "_7-h";
export var navigationFooter = "_7-g";
export var pageShell = "_7-0";
export var placeholderAvailable = "_7-11";
export var placeholderBox = "_7-14";
export var placeholderBusy = "_7-13";
export var placeholderUnavailable = "_7-12";
export var profile = "_7-k";
export var profileContainer = "_7-m";
export var profileDropdown = "_7-n";
export var profileImage = "_7-l";
export var profileMain = "_7-o";
export var profileSubtitle = "_7-q";
export var profileTitle = "_7-p";
export var reorderIcon = "_7-r";
export var sentLine = "_7-u";
export var settingsHeader = "_7-s";
export var sidenavTextColor = "_7-y";
export var spamLine = "_7-t";
export var subitemWithTag = "_7-4";
export var supportItems = "_7-j";
export var teamText = "_7-10";
export var viewLine = "_7-x";
export var viewLineButton = "_7-w";
export var viewLineButtons = "_7-v";